import React from 'react';
import { CreditCard, Shield, Clock } from 'lucide-react';

const PaymentOptions = ({ variant = 'full', className = '' }) => {
  // Variant: 'full' = sezione completa, 'compact' = badge compatto, 'inline' = linea singola
  
  if (variant === 'inline') {
    return (
      <div className={`flex flex-wrap items-center justify-center gap-4 text-sm text-gray-600 ${className}`}>
        <div className="flex items-center gap-2">
          <svg className="w-5 h-5" viewBox="0 0 24 24" fill="#003087">
            <path d="M7.076 21.337H2.47a.641.641 0 0 1-.633-.74L4.944 3.72a.77.77 0 0 1 .757-.65h6.565c2.18 0 3.708.584 4.543 1.736.392.544.627 1.186.713 1.96.09.815.02 1.787-.21 2.891l-.015.076v.055c-.468 2.478-1.576 4.18-3.292 5.06-1.65.846-3.768.897-5.313.897H7.692a.77.77 0 0 0-.757.65l-.859 4.942z"/>
            <path d="M18.622 7.738c-.1 5.048-3.233 6.993-7.533 6.993H9.522a.77.77 0 0 0-.757.65l-.924 5.322-.263 1.512a.641.641 0 0 0 .633.74h3.257a.77.77 0 0 0 .757-.65l.753-4.335a.77.77 0 0 1 .757-.65h1.568c3.45 0 6.15-1.398 6.937-5.45.328-1.69.158-3.102-.618-4.132z" fill="#0070E0"/>
          </svg>
          <span>PayPal</span>
        </div>
        <span className="text-gray-300">|</span>
        <div className="flex items-center gap-2">
          <Clock className="w-4 h-4 text-sky-500" />
          <span>Paga in 3 rate</span>
        </div>
        <span className="text-gray-300">|</span>
        <div className="flex items-center gap-2">
          <CreditCard className="w-4 h-4 text-gray-500" />
          <span>Bonifico</span>
        </div>
      </div>
    );
  }
  
  if (variant === 'compact') {
    return (
      <div className={`bg-gradient-to-r from-blue-50 to-sky-50 border border-blue-100 rounded-lg p-4 ${className}`}>
        <div className="flex flex-wrap items-center justify-center gap-4">
          <div className="flex items-center gap-2">
            <svg className="w-6 h-6" viewBox="0 0 24 24" fill="#003087">
              <path d="M7.076 21.337H2.47a.641.641 0 0 1-.633-.74L4.944 3.72a.77.77 0 0 1 .757-.65h6.565c2.18 0 3.708.584 4.543 1.736.392.544.627 1.186.713 1.96.09.815.02 1.787-.21 2.891l-.015.076v.055c-.468 2.478-1.576 4.18-3.292 5.06-1.65.846-3.768.897-5.313.897H7.692a.77.77 0 0 0-.757.65l-.859 4.942z"/>
              <path d="M18.622 7.738c-.1 5.048-3.233 6.993-7.533 6.993H9.522a.77.77 0 0 0-.757.65l-.924 5.322-.263 1.512a.641.641 0 0 0 .633.74h3.257a.77.77 0 0 0 .757-.65l.753-4.335a.77.77 0 0 1 .757-.65h1.568c3.45 0 6.15-1.398 6.937-5.45.328-1.69.158-3.102-.618-4.132z" fill="#0070E0"/>
            </svg>
            <span className="font-medium text-gray-800">Paga con PayPal</span>
          </div>
          <div className="h-4 w-px bg-blue-200 hidden sm:block" />
          <div className="flex items-center gap-2 bg-white px-3 py-1 rounded-full border border-blue-200">
            <Clock className="w-4 h-4 text-sky-500" />
            <span className="text-sm font-medium text-gray-700">Paga in 3 rate senza interessi</span>
          </div>
        </div>
      </div>
    );
  }
  
  // Full variant
  return (
    <div className={`bg-gradient-to-br from-blue-50 via-white to-sky-50 border border-blue-100 rounded-xl p-6 lg:p-8 ${className}`}>
      <div className="flex flex-col lg:flex-row items-center gap-6 lg:gap-10">
        {/* PayPal Logo & Title */}
        <div className="flex items-center gap-3">
          <div className="bg-white p-3 rounded-lg shadow-sm border border-gray-100">
            <svg className="w-10 h-10" viewBox="0 0 24 24">
              <path d="M7.076 21.337H2.47a.641.641 0 0 1-.633-.74L4.944 3.72a.77.77 0 0 1 .757-.65h6.565c2.18 0 3.708.584 4.543 1.736.392.544.627 1.186.713 1.96.09.815.02 1.787-.21 2.891l-.015.076v.055c-.468 2.478-1.576 4.18-3.292 5.06-1.65.846-3.768.897-5.313.897H7.692a.77.77 0 0 0-.757.65l-.859 4.942z" fill="#003087"/>
              <path d="M18.622 7.738c-.1 5.048-3.233 6.993-7.533 6.993H9.522a.77.77 0 0 0-.757.65l-.924 5.322-.263 1.512a.641.641 0 0 0 .633.74h3.257a.77.77 0 0 0 .757-.65l.753-4.335a.77.77 0 0 1 .757-.65h1.568c3.45 0 6.15-1.398 6.937-5.45.328-1.69.158-3.102-.618-4.132z" fill="#0070E0"/>
            </svg>
          </div>
          <div>
            <h3 className="text-lg font-semibold text-gray-900">Pagamenti flessibili</h3>
            <p className="text-sm text-gray-500">con PayPal e carte</p>
          </div>
        </div>
        
        {/* Divider */}
        <div className="hidden lg:block h-16 w-px bg-gradient-to-b from-transparent via-blue-200 to-transparent" />
        
        {/* Payment Options */}
        <div className="flex-1 grid grid-cols-1 sm:grid-cols-3 gap-4">
          {/* PayPal */}
          <div className="flex items-center gap-3 bg-white p-3 rounded-lg border border-gray-100">
            <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0">
              <CreditCard className="w-5 h-5 text-blue-600" />
            </div>
            <div>
              <p className="font-medium text-gray-900 text-sm">PayPal</p>
              <p className="text-xs text-gray-500">Conto o carta</p>
            </div>
          </div>
          
          {/* Pay in 3 */}
          <div className="flex items-center gap-3 bg-white p-3 rounded-lg border-2 border-sky-200 relative overflow-hidden">
            <div className="absolute top-0 right-0 bg-sky-500 text-white text-[10px] px-2 py-0.5 rounded-bl font-medium">
              POPOLARE
            </div>
            <div className="w-10 h-10 rounded-full bg-sky-100 flex items-center justify-center flex-shrink-0">
              <Clock className="w-5 h-5 text-sky-600" />
            </div>
            <div>
              <p className="font-medium text-gray-900 text-sm">Paga in 3 rate</p>
              <p className="text-xs text-gray-500">Senza interessi</p>
            </div>
          </div>
          
          {/* Bonifico */}
          <div className="flex items-center gap-3 bg-white p-3 rounded-lg border border-gray-100">
            <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0">
              <Shield className="w-5 h-5 text-gray-600" />
            </div>
            <div>
              <p className="font-medium text-gray-900 text-sm">Bonifico</p>
              <p className="text-xs text-gray-500">Bancario</p>
            </div>
          </div>
        </div>
      </div>
      
      {/* Footer note */}
      <p className="text-center text-xs text-gray-500 mt-4 pt-4 border-t border-gray-100">
        Pagamento sicuro tramite PayPal. Per importi superiori a €200 è disponibile il pagamento in 3 rate senza interessi.
      </p>
    </div>
  );
};

export default PaymentOptions;
